import React, { useState, useEffect } from 'react';
import { FiExternalLink, FiGithub, FiPlay, FiCode, FiSmartphone, FiShoppingBag, FiLayout, FiFileText, FiGrid } from 'react-icons/fi';
import axios from 'axios';

const iconMap = {
  'site': FiLayout,
  'sistema': FiGrid,
  'app': FiSmartphone,
  'landing': FiFileText,
  'ecommerce': FiShoppingBag,
  'blog': FiFileText
};

const emojiMap = {
  'dashboard': '📊',
  'ecommerce': '🛍️',
  'landing': '🎯',
  'mobile': '📱',
  'blog': '📝',
  'agenda': '📅',
  'site': '🌐'
};

function ProjetosDemo() {
  const [projetos, setProjetos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('todos');

  useEffect(() => {
    fetchProjetos();
  }, []);

  const fetchProjetos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/projetos-demo`);
      const ordenados = response.data.sort((a, b) => {
        if (a.destaque && !b.destaque) return -1;
        if (!a.destaque && b.destaque) return 1;
        return (a.ordem || 0) - (b.ordem || 0);
      });
      setProjetos(ordenados);
    } catch (error) {
      console.error('Erro ao carregar demos:', error);
    } finally {
      setLoading(false);
    }
  };

  const projetosFiltrados = filtro === 'todos' 
    ? projetos 
    : projetos.filter(p => p.tipo === filtro);

  if (loading) return <div className="loading">Carregando demonstrações...</div>;

  return (
    <section id="demos" className="projetos-demo">
      <div className="section-title">
        <h2>Veja na Prática</h2>
        <p>Projetos de demonstração funcionando. Clique e explore!</p>
      </div>


      {/* Grid de Demos */}
      <div className="demo-grid">
        {projetosFiltrados.map((projeto) => {
          const emoji = emojiMap[projeto.imagem] || '💻';

          return (
            <div key={projeto.id} className={`demo-card ${projeto.destaque ? 'destaque' : ''}`}>
              {projeto.destaque && <span className="demo-badge">⭐ Destaque</span>}
              
              {/* Preview Visual */}
              <div className="demo-preview">
                <span className="demo-emoji">{emoji}</span>
                <div className="demo-overlay">
                  <a href={projeto.link_demo} target="_blank" rel="noopener noreferrer" className="btn-play">
                    <FiPlay /> Ver Demo
                  </a>
                </div>
              </div>

              {/* Info */}
              <div className="demo-info">
                
                <h3>{projeto.titulo}</h3>
                <p>{projeto.descricao}</p>


                {/* Ações */}
                <div className="demo-acoes">
                  <a 
                    href={projeto.link_demo} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-demo"
                  >
                    <FiExternalLink /> Acessar Demo
                  </a>
                  
                  {projeto.link_codigo && (
                    <a 
                      href={projeto.link_codigo} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn-codigo"
                    >
                      <FiGithub /> Código
                    </a>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

    </section>
  );
}

export default ProjetosDemo;